import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { zodFlavorId } from "./ids.mjs";
import { ExperienceFlowEnum, PaymentMethodEnum, SIGNUP_TRIAL_DURATION_DAYS } from "./types.mjs";
import { experienceFlowConfigSchema } from "./referral.mjs";
import z from "zod";

// src/models/branding.ts
const brandPaymentMethodConfigIndividualSchema = z.object({
	promoCode: z.string().nullable().default(null),
	trialDays: z.number().int().min(0).max(30).default(0)
});
const brandPaymentMethodConfigSponsoredSchema = z.object({
	consultationIncluded: z.boolean().default(false),
	expirationBannerTitle: z.string().trim().nullable().optional(),
	expirationBannerSubtitle: z.string().trim().nullable().optional(),
	endDate: z.any().transform(zodTransformFirestoreTimestampToDate).nullable(),
	durationMonths: z.number().nullable()
}).refine((data) => data.endDate || data.durationMonths, {
	message: "Either end date or duration months must be provided",
	path: ["endDate", "durationMonths"]
});
const brandPaymentMethodConfigSchema = z.object({
	["default"]: brandPaymentMethodConfigIndividualSchema.nullable().default(null),
	["sponsored"]: brandPaymentMethodConfigSponsoredSchema.nullable().default(null)
});
const brandingProgramTypeSchema = z.enum(["organization", "individual"]);
const brandingSchema = z.object({
	id: zodFlavorId(),
	code: z.string(),
	programType: brandingProgramTypeSchema.nullable().optional(),
	activeTimeFrame: z.object({
		startDate: z.any().transform(zodTransformFirestoreTimestampToDate),
		endDate: z.any().transform(zodTransformFirestoreTimestampToDate).nullable()
	}),
	experienceFlow: z.enum(Object.values(ExperienceFlowEnum)),
	paymentMethod: z.enum(Object.values(PaymentMethodEnum)),
	experienceFlowConfigs: experienceFlowConfigSchema,
	paymentMethodConfigs: brandPaymentMethodConfigSchema,
	createdAt: z.any().transform(zodTransformFirestoreTimestampToDate),
	updatedAt: z.any().transform(zodTransformFirestoreTimestampToDate)
}).refine((data) => data.paymentMethodConfigs[data.paymentMethod], {
	message: "Payment method config is required",
	path: ["paymentMethodConfigs", "paymentMethod"]
});
const DefaultBranding = {
	id: "default",
	code: "default",
	experienceFlow: "default",
	activeTimeFrame: {
		startDate: /* @__PURE__ */ new Date(0),
		endDate: null
	},
	paymentMethod: "default",
	experienceFlowConfigs: {
		["default"]: {},
		["astrazeneca"]: null
	},
	paymentMethodConfigs: {
		["default"]: {
			promoCode: null,
			trialDays: 14
		},
		["sponsored"]: null
	},
	createdAt: /* @__PURE__ */ new Date(0),
	updatedAt: /* @__PURE__ */ new Date(0)
};

export { DefaultBranding, brandPaymentMethodConfigSchema, brandingProgramTypeSchema, brandingSchema };
//# sourceMappingURL=branding.mjs.map